import { CSSProperties } from 'styled-components'

export function responsive (width: number, styles: CSSProperties) {
  return {
    [`@media (max-width: ${width}px)`]: styles
  }
}
